const $ = jQuery;

export default function faqArchive() {
	const $items = $('.faq-card__item');
	if (!$items.length) return;

	$('.js-accordion-trigger').on('click', function () {
		const $this = $(this);
		const $parent = $this.parent();
		const $content = $parent.find('.js-accordion-content');

		$items.not($parent).removeClass('active').find('.js-accordion-content').slideUp(500);
		$content.slideToggle(500);
		$parent.toggleClass('active');
	});

	// Function to create reset filters
	function createResetFiltersParagraph() {
		return $('<p class="reset-filters-text mb-0 flex align-center mr-4" data-term-id="reset-filters">Reset filters</p>');
	}

	// Function to show all FAQ items
	function showAllItems() {
		$('.faq-archive__posts-container .faq-card__item').show();
		$('.faq__category').text('All FAQs');
	}

	function filterByCategory(clicked) {
		$('.faq-archive__posts-container .faq-card__item').each(function () {
			const $card = $(this);

			let termIds = $card.data('term-ids');
			let termSlugs = $card.data('term-slugs');

			if (typeof termIds === 'string') {
				termIds = termIds.split(',').map(s => s.trim()).filter(Boolean);
			}
			if (typeof termSlugs === 'string') {
				termSlugs = termSlugs.split(',').map(s => s.trim()).filter(Boolean);
			}

			termIds = Array.isArray(termIds) ? termIds : (termIds ? [termIds] : []);
			termSlugs = Array.isArray(termSlugs) ? termSlugs : (termSlugs ? [termSlugs] : []);

			const idsStr = termIds.map(String);
			const slugsStr = termSlugs.map(String);

			let shouldShow = false;

			if (clicked === 'all') {
				shouldShow = true;
			} else if (/^\d+$/.test(clicked)) {
				if (idsStr.includes(clicked)) shouldShow = true;
			} else {
				if (slugsStr.includes(clicked)) shouldShow = true;
			}

			if (shouldShow) {
				$card.show();
			} else {
				$card.hide();
			}
		});
	}

	$('.js-faq-archive-categories').on('click', '[data-term-id]', function (e) {
		e.preventDefault();
		const $btn = $(this);
		const clickedAttr = $btn.attr('data-term-id') || '';
		const clicked = clickedAttr.toString();

		// Handle reset filters paragraph
		if (clicked === 'reset-filters') {
			$('.js-faq-archive-categories [data-term-id]').removeClass('active');
			showAllItems();
			
			const $resetParagraph = $('.js-faq-archive-categories [data-term-id="reset-filters"]');
			$resetParagraph.removeClass('visible');
			setTimeout(() => {
				$resetParagraph.remove();
			}, 300);
			return;
		}

		// Filter by category
		$('.js-faq-archive-categories [data-term-id]').removeClass('active');
		$btn.addClass('active');

		const title = $btn.text().trim();
		$('.faq__category').text(title);

		const $resetParagraph = $('.js-faq-archive-categories [data-term-id="reset-filters"]');
		if (!$resetParagraph.length) {
			const $newResetParagraph = createResetFiltersParagraph();
			$('.js-faq-archive-categories').prepend($newResetParagraph);
			
			setTimeout(() => {
				$newResetParagraph.addClass('visible');
			}, 10);
		}

		filterByCategory(clicked);
	});

	const $categoryButtons = $('.js-faq-archive-categories [data-term-id]');
	if ($categoryButtons.length === 1) {
		const $onlyBtn = $categoryButtons.first();
		$('.faq__category').text($onlyBtn.text().trim());
	}
}